import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { ciInterface2 } from 'src/app/util/interfaces/ci';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CmdbRegisterPageBondService {
	private readonly http = inject(HttpClient);
	private readonly authLoginService = inject(AuthLoginService);

	private postBondCiUrl = environment.baseApiUrl + 'cmdb/relations/{idCi}';
	private deleteBondCiUrl = environment.baseApiUrl + 'cmdb/relations/{idCi}/{idRelation}';
	private deleteMultipleBondCiUrl = environment.baseApiUrl + 'cmdb/multipleRelations/{idCi}';

	constructor() {}

	bondCi(ci: ciInterface2, bondCi: ciInterface2, type_bond: string): Observable<any> {
		const postBondCiUrl = this.postBondCiUrl.replace('{idCi}', ci.id);
		const body = {
			bond: [
				{
					relatedCiId: bondCi.id,
					relationType: type_bond,
				},
			],
		};

		return this.http.post<any[]>(postBondCiUrl, body, { headers: this.authLoginService.getHttpHeaders() });
	}

	unbondCi(idCi: string, idRelation: string): Observable<any> {
		const deleteBondCiUrl = this.deleteBondCiUrl.replace('{idCi}', idCi).replace('{idRelation}', idRelation);
		return this.http.delete(deleteBondCiUrl, { headers: this.authLoginService.getHttpHeaders() });
	}

	unbondCiMultiples(idCi: string, listCiBond): Observable<any> {
		const deleteMultipleBondCiUrl = this.deleteMultipleBondCiUrl.replace('{idCi}', idCi);
		const body = {
			content: listCiBond,
		};
		return this.http.put(deleteMultipleBondCiUrl, body, { headers: this.authLoginService.getHttpHeaders() });
	}
}
